// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1a74cbd0","453":"fa488c62","455":"f8dde2eb"}[chunkId] + ".chunk.js";
};